import { useState } from "react";

import { Heading, Paragraph } from "@fronterahealth/frontera-ui-components";

import { useListRulePackages } from "@api/rest/types-and-hooks";
import { PackagesTab } from "@pages/QARules/PackagesTab";

/** The QA package manager. Per-org and per-template settings live on those detail pages. */
export const QARules: React.FC = () => {
  const [showArchived, setShowArchived] = useState(false);

  const { data, isLoading } = useListRulePackages({ include_archived: showArchived });
  const packages = data?.status === 200 ? data.data.results : [];

  return (
    <div className="flex min-h-full flex-col">
      <div className="flex flex-col gap-1 px-16 pb-4 pt-8">
        <Heading size="medium">QA Rules</Heading>
        <Paragraph className="text-text-secondary">
          Packages group QA rules. Base packages apply to every report, insurance packages to templates with a matching
          payor, and custom packages wherever they&apos;re attached to an org or template. Use an org&apos;s or
          template&apos;s QA Rules tab to attach packages, turn them off, and preview what a report gets.
        </Paragraph>
      </div>
      <div className="px-16 py-4">
        <PackagesTab
          packages={packages}
          isLoading={isLoading}
          showArchived={showArchived}
          setShowArchived={setShowArchived}
        />
      </div>
    </div>
  );
};
